import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing, { PAGE_TITLES } from "@/pages/Landing";
import ConditionPage from "@/pages/ConditionPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import SeoPage from "@/pages/SeoPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/services" element={<Landing section="services" title={PAGE_TITLES.services} />} />
        <Route path="/about" element={<Landing section="about" title={PAGE_TITLES.about} />} />
        <Route path="/why-us" element={<Landing section="why" title={PAGE_TITLES.why} />} />
        <Route path="/testimonials" element={<Landing section="testimonials" title={PAGE_TITLES.testimonials} />} />
        <Route path="/pricing" element={<Landing section="pricing" title={PAGE_TITLES.pricing} />} />
        <Route path="/contact" element={<Landing section="contact" title={PAGE_TITLES.contact} />} />
        <Route path="/physiotherapy/:slug" element={<ConditionPage />} />
        {/* Legacy path preserved so old sitemap-crawled URLs keep working */}
        <Route path="/services/:slug" element={<ConditionPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/seo-not-visible" element={<SeoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
